import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'hrms/attendance',
        data: { pageTitle: 'Attendance' },
        loadChildren: () =>
          import('./attendance/attendance.module').then(
            (m) => m.AttendanceModule
          ),
      },
      {
        path: 'hrms/policies',
        data: { pageTitle: 'Policies' },
        loadChildren: () =>
          import('./policies/policies.module').then((m) => m.PoliciesModule),
      },
      {
        path: 'hrms/rostering',
        data: { pageTitle: 'Rostering' },
        loadChildren: () =>
          import('./rostering/rostering.module').then((m) => m.RosteringModule),
      },
      {
        path: 'hrms/shift',
        data: { pageTitle: 'Shift' },
        loadChildren: () =>
          import('./shift/shift.module').then((m) => m.ShiftModule),
      },
      {
        path: 'hrms/workforce',
        data: { pageTitle: 'Workforce' },
        loadChildren: () =>
          import('./workforce/workforce.module').then((m) => m.WorkforceModule),
      },
    ]),
  ],
})
export class HrmsRoutingModule {}
